/**
 * Extract element Attribute and use it as key value pair, useful for state updating from input fields
 * @param e {object}
 * @param attribute {string}
 * @return {object}
 */
export default function setHtmlAttributeAsKeyValuePair(e, attribute) {
    return {[e.target.getAttribute(attribute)]: e.target.value}
}